import React, { Suspense, lazy } from 'react'
const LazyHeavy = lazy(() => import('../../pages/Forum/Forum'));

export default function AsyncForum() {
  return (
      <Suspense fallback={<div>Loading...</div>}>
        <LazyHeavy />
      </Suspense>
  )
}